module.exports = __webpack_public_path__ + "img/f28.397a6c10.jpg";